import _toConsumableArray from "D:/coding/pmv5-fe/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import pageMixin from "../mixins/page";
import Axios from "axios";
import TrialSheetReviewModal from "./TrialSheetReviewModal";
import TableDetailModal from "./TableDetailModal";
export default {
  name: "trial-sheet",
  mixins: [pageMixin],
  components: {
    TrialSheetReviewModal: TrialSheetReviewModal,
    TableDetailModal: TableDetailModal
  },
  data: function data() {
    var _this = this;
    return {
      searchText: "",
      searchStatus: "待审核",
      columns: [{
        type: "selection",
        width: 60,
        align: "center"
      }, {
        title: "试用类别",
        // width: 160,
        width: 110,
        sortable: true,
        key: "category"
      }, {
        title: "试用单位",
        key: "customer",
        sortable: true
      }, {
        title: "点数",
        width: 80,
        key: "point_num",
        sortable: true
      }, {
        title: "产品名称",
        sortable: true,
        key: "product_details",
        render: function render(h, params) {
          return h('span', params.row.product_details ? params.row.product_details.product_name : "");
        }
      }, {
        title: "申请人",
        width: 100,
        sortable: true,
        render: function render(h, params) {
          return h('span', params.row.create_by ? params.row.create_by.realname : "");
        }
      }, {
        title: "审核人",
        width: 100,
        sortable: true,
        render: function render(h, params) {
          return h('span', params.row.reviewer ? params.row.reviewer.realname : "");
        }
      }, {
        title: "状态",
        width: 80,
        sortable: true,
        key: "status"
      }, {
        title: "申请时间",
        width: 110,
        sortable: true,
        render: function render(h, params) {
          return h('span', _this.$moment(params.row.create_at).format('YYYY-MM-DD'));
        }
      }, {
        title: "过期时间",
        width: 110,
        sortable: true,
        key: "expire_date"
      }, {
        title: "备注",
        key: "remark"
      }, {
        title: "操作",
        width: 100,
        align: 'center',
        slot: 'btns'
      }],
      data: [],
      selection: [],
      showReviewModal: false,
      // 申请详情
      showTableDetail: false,
      tableDetail: {},
      tableDetailColumns: [{
        title: "ID",
        key: "id"
      }, {
        title: "试用类别",
        key: "category"
      }, {
        title: "试用单位",
        key: "customer"
      }, {
        title: "申请时间",
        render: function render(h, params) {
          return h('span', _this.$moment(params.row.create_at).format('YYYY-MM-DD HH:mm:ss'));
        }
      }, {
        title: "申请人",
        key: "create_by",
        render: function render(h, params) {
          return h('span', params.row.create_by ? params.row.create_by.username : "");
        }
      }, {
        title: "点数",
        key: "point_num"
      }, {
        title: "产品名称",
        key: "product_details",
        render: function render(h, params) {
          return h('span', params.row.product_details ? params.row.product_details.product_name : "");
        }
      }, {
        title: "状态",
        key: "status"
      }, {
        title: "过期时间",
        key: "expire_date"
      }, {
        title: "备注",
        key: "remark"
      }, {
        title: "审核备注",
        key: "review_remark"
      }, {
        title: "审核人",
        render: function render(h, params) {
          return h('span', params.row.reviewer ? params.row.reviewer.realname : '');
        }
      }, {
        title: "审核时间",
        render: function render(h, params) {
          return h('span', _this.$moment(params.row.review_at).format('YYYY-MM-DD HH:mm:ss'));
        }
      }],
      isResent: false
    };
  },
  created: function created() {
    this.refresh();
  },
  methods: {
    refresh: function refresh() {
      var _this2 = this;
      var onFinish = this.setLoading.bind(this, false);
      this.setLoading(true);
      var data = {
        name: this.searchText,
        order_by: "-id",
        page: this.currentPage,
        per_page: this.pageSize
      };
      if (this.searchStatus !== '全部') {
        data.status = this.searchStatus;
      }
      Axios.get("trials/", {
        params: data
      }).then(function (resp) {
        _this2.data = resp.data.trials;
        _this2.setPageVars(resp.data.page_info);
      }).then(onFinish, onFinish);
    },
    deleteSelection: function deleteSelection() {
      var _this3 = this;
      var id = this.selection[0].id;
      Axios.delete("trials/".concat(id, "/")).then(function (res) {
        console.log(res);
        _this3.refresh();
      });
    },
    onModalClose: function onModalClose(val) {
      this.showTableDetail = false;
      val && this.refresh();
    },
    onSelectionChange: function onSelectionChange(rows) {
      var _this$selection;
      this.selection.length = 0;
      (_this$selection = this.selection).push.apply(_this$selection, _toConsumableArray(rows));
    },
    viewDetails: function viewDetails(rows) {
      // let detail = encodeURI(encodeURI(JSON.stringify(rows)))
      // window.open('tableDetail.html?detail=' + detail)

      if (rows.status === "已通过" && this.tableDetailColumns[0].key !== 'sn_no') {
        this.tableDetailColumns.unshift({
          title: "产品ID",
          key: "sn_no",
          render: function render(h, params) {
            return h('span', params.row.sn ? params.row.sn.no : '');
          }
        });
      }
      if (rows.status !== "已通过" && this.tableDetailColumns[0].key === 'sn_no') {
        this.tableDetailColumns.shift();
      }
      this.tableDetail = rows;
      this.showTableDetail = true;
    },
    resentEmail: function resentEmail() {
      var _this4 = this;
      this.isResent = true;
      Axios.post("trials/".concat(this.tableDetail.id, "/resend-email/")).then(function (resp) {
        var code = resp.data.code;
        if (code === 0) {
          _this4.$Message.success('重发邮件 成功！');
          _this4.refresh();
        }
      }).finally(function () {
        _this4.isResent = false;
      });
    },
    exportExcel: function exportExcel() {
      var url = '/pmv5/service/trials/export';
      window.open(url);
    }
  }
};